module.exports = __webpack_public_path__ + "img/overview10.a2023e5d.png";